import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ConverterUTC from "../../ConverterUTC/ConverterUTC";
import { SettingsUserState, TaskGet } from "../../Types/Types";
import './SelectDateCalendar.css';
import Deadlineinput from "./DeadlineInput/Deadlineinput";
import TaskCalendar from "../../UIcomponents/Calendar/Base/Calendar";
import { ReactComponent as CalendarPic } from "../../icons/svg/ModalChangingTask/calendar.svg";
import { ReactComponent as RepeatLogo } from "../SelectRepeatTemplate/static/repeatTemplate_icon.svg";
import ChangePeriodDateButtons from "./ChangePeriodDateButtons/ChangePeriodDateButtons";
import DDSelectRepeatTemplate from "../SelectRepeatTemplate/DDSelectRepeatTemplate";
import useOutside from "../../customHooks/useOutside";

interface SelecOfDateProps {
    disabled?: boolean,
    addTaskButtons?: boolean,
    deadlineinput?: boolean, 
    statisticsButton?: boolean,
    time?: string,
    dateStart?: Date,
    disabledItem?: boolean,
    pushDataTime?: Function,
    getDatePayload: Function,
    showIcon?: boolean,
    // dataTask: TaskGet,
    repeatPayload?: {
        isRepeatTemplate: boolean,
        templateData: TaskGet,
        templateUpdateFunction: Function
    }
    pickerPosition?: 'RightCenter' | 'RightBottom' | 'RightTop' | 'LeftCenter' | 'Center'
}

export default function DropDownSelectOfDate({addTaskButtons,
    disabled=false, 
    deadlineinput, 
    statisticsButton,
    time,
    dateStart,
    pushDataTime,
    getDatePayload,
    showIcon = true,
    repeatPayload,
    pickerPosition='Center'}: SelecOfDateProps) {
    const [isOpenDD, setIsOpenDD] = useState<boolean>(false);
    // const [dateRange, setDateRange] = useState<Date[]>([new Date() , new Date()])
    const [pickedDate, setPickedDate] = useState<Date | null>(dateStart ?? new Date());
    const [currentPeriod, setCurrentPeriod] = useState<string>('today')
    const settingsUser = useSelector((state: SettingsUserState) => state.settings.settings);
    const dateToday = ConverterUTC({method: 'object', settingsUser: settingsUser})
    const dateTomorrow = new Date();
    const refSelectOfDate = useOutside(() => setTimeout(() => {
        setIsOpenDD(false)
    }, 50))
    // useEffect (() => {
    //     setPickedDate(dateStart ?? new Date())
    // }, [dateStart])
    dateTomorrow.setDate(new Date().getDate() + 1)
    // const refSelectOfDate = useRef<null | HTMLDivElement>(null)
    const resetDeadlineRef = useRef<any>(null)
    const daysOfWeek = [
        'Воскресенье',
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота'
    ]

    if (!(dateToday instanceof Date)) {
        throw new Error("dateToday должен быть экземпляром Date");
    }

    // useEffect(() => {
    //     if (pickedDate?.toLocaleDateString() === dateToday.toLocaleDateString()) {
    //         setCurrentPeriod('today')
    //     } else if (statisticsButton && dateRange) {
    //         if (dateRange[0].toLocaleDateString() === dateToday.toLocaleDateString() &&
    //             dateRange[1].toLocaleDateString() === dateToday.toLocaleDateString()) {
    //             setCurrentPeriod('onToday')
    //         }
    //     } else {
    //         setCurrentPeriod('')
    //     }
    // }, [pickedDate])
    // useOutsideClick(refSelectOfDate, () => setIsOpenDD(!isOpenDD), isOpenDD)

    const handleIsOpen = (e: any) => {
        setTimeout(() => {
            setIsOpenDD(true)
        }, 50);
        // e.stopPropagation()
    }

    const checkValueInputDate = (value: Date | null, time?: string) => {
        if (!(dateToday instanceof Date)) {
            throw new Error("dateToday должен быть экземпляром Date");
        }

        const toZeroHoursToday = dateToday.setHours(0,0,0,0)
        const toZeroHoursTomorrow = dateTomorrow.setHours(0,0,0,0)
        
        const toNormalizeDate = (date: string) => {
            if (date === '') {
                return date
            } else {
                const parts = date.split('.');
                const day = parseInt(parts[0], 10);  
                const month = parseInt(parts[1], 10) - 1; 
                const year = parseInt(parts[2], 10);
                return new Date(year, month, day);
            }
        }

        const getDayOfDate = (value: Date | null) => {
            if (value === null) {
                return 'Без срока'
            } else if (value.setHours(0,0,0,0) === toZeroHoursToday) {
                return 'Сегодня'
            } else if (value.setHours(0,0,0,0) === toZeroHoursTomorrow) {
                return 'Завтра'
            } else {
                const firstDayOfWeek = new Date()
                let getfirst = new Date(firstDayOfWeek.setDate(firstDayOfWeek.getDate() - firstDayOfWeek.getDay() + 1))
                const lastDayOfWeek = new Date()
                let getlast = new Date(lastDayOfWeek.setDate(lastDayOfWeek.getDate() - lastDayOfWeek.getDay() + 7))
                if (toNormalizeDate(value.toLocaleDateString() ?? '') >= getfirst && toNormalizeDate(value.toLocaleDateString() ?? '') <= getlast) {
                    return daysOfWeek[pickedDate!.getDay()]
                } else {
                    return value.toLocaleDateString()
                }
            } 
        }

        const getTimeOfDate = (time: string) => {
            if (time === '') {
                return ''
            } else {
                return time
            }
        }

 
        return getDayOfDate(value) + ' ' + getTimeOfDate(time ?? '')
    }
    
    const getDate = (payload: Date) => {
        const getPeriod = () => {
            if (payload.toLocaleDateString() === dateToday.toLocaleDateString()) {
                return 'today'
            } else if (payload.toLocaleDateString() === dateTomorrow.toLocaleDateString()) {
                return 'tomorrow'
            } else  {
                return ''
            }
        }      
        updateDataDate({date: payload, period: getPeriod()})
    }

    const getRange = (payload: Date[]) => {
        updateDataRange({arr: payload, period: ''})
    }

    const updateDataDate = (payload: {date: Date | null, period: string}) => {        
        setPickedDate(payload.date ?? null)
        setCurrentPeriod(payload.period)
        if (getDatePayload) {
            getDatePayload(payload.date?.toLocaleDateString() ?? '')
        }
        if (payload.period === 'no_date') {
            resetDeadlineRef.current.reset()
            if (pushDataTime) {
                pushDataTime('')
            }
        }
    }

    const updateDataRange = (payload: {arr: Date[], period: string}) => {
        setCurrentPeriod(payload.period)
        // setDateRange(payload.arr)
        // if (getDatePayload) {
        //     getDatePayload(payload.arr)
        // }
    }
    
    const updateTime = (time: string) => {
        if (currentPeriod === 'no_date') {
            updateDataDate({date: dateToday, period: 'today'})
        }
        if (pushDataTime) {
            pushDataTime(time)
        } 
    }
    
    useEffect(() => {
        if (isOpenDD && (pickerPosition === 'RightCenter' || pickerPosition === 'LeftCenter') && refSelectOfDate.current) {
            refSelectOfDate.current.style.top = `-${refSelectOfDate.current?.clientHeight / 3}px`;
        }
    }, [isOpenDD, refSelectOfDate, pickerPosition])
        

    return (
        <div  className={`DatePickerBlock ${pickerPosition ?? ''} ${disabled && 'disabled_calendar'}`}>
            <div className={`DatePicker ${isOpenDD ? 'active' : ''}`} tabIndex={0} onClick={(e: any) => {
                    handleIsOpen(e)
                    }}>
                {
                    showIcon &&
                    <CalendarPic className="DatePicker-icon"/>
                }
                <span className='DatePicker-container' style={!showIcon ? {justifyContent: 'center', textAlign: 'center'} : {justifyContent: 'space-between'}}>
                    <div className="DatePicker-container__div" style={!showIcon ? {justifyContent: 'center'} : {justifyContent: 'space-between'}}>
                        <p className="DatePicker-container__title">{checkValueInputDate(pickedDate ?? null, time ?? '')}</p>
                        {   
                            repeatPayload?.templateData && repeatPayload?.templateData.repitPeriod > 0 && 
                                <RepeatLogo className="DatePicker-icon-2nd" style={{fill: '#5932EA', width: '14px', height: '14px'}}/>
                        }
                    </div>
                </span>
            </div>
                    {   
                        isOpenDD &&
                            <div className={`DatePicker-calendar ${pickerPosition ?? ''}`}>
                                        <div className="DatePicker-calendar__container"/>
                                        <div className={`DatePicker-calendar__Calendar ${pickerPosition ?? ''}`}
                                            ref={refSelectOfDate}
                                            id='DatePicker'
                                            >
                                            {/* <ul className='calendar__list'> */}
                                            <ul className="DatePicker-calendar__Calendar-list">
                                            {
                                                statisticsButton && 
                                                <ChangePeriodDateButtons buttonsVariant="statistic" 
                                                    currentDate={dateToday} 
                                                    pickedPeriod={currentPeriod} 
                                                    onChangePeriod={updateDataRange} /> 
                                            }
                                            {
                                                addTaskButtons &&
                                                <ChangePeriodDateButtons buttonsVariant="addTask" 
                                                    currentDate={dateToday} 
                                                    pickedPeriod={currentPeriod} 
                                                    onChangePeriod={updateDataDate} /> 
                                            }
                                            {
                                                deadlineinput && 
                                                <Deadlineinput ref={resetDeadlineRef}
                                                    onChangeFunc={updateTime}
                                                    showLogo={true}
                                                    time={time ?? ''}
                                                />
                                            }
                                            {
                                                repeatPayload?.isRepeatTemplate &&
                                                    <DDSelectRepeatTemplate viewVariant='EditTask'
                                                        datePayload={pickedDate}
                                                        onSelectDay={getDate}  
                                                        templateData={repeatPayload.templateData}
                                                        updateTemplate={repeatPayload.templateUpdateFunction}/>
                                            }
                                            <TaskCalendar
                                                onCloseCalendar={setIsOpenDD} 
                                                datePayload={pickedDate}
                                                // initialRange={dateRange}
                                                isRangeMode={statisticsButton ?? false}
                                                isPreviosDateAllow={statisticsButton ?? false} 
                                                onSelectDay={getDate} 
                                                onSelectRange={getRange}/>
                                            </ul>
                                        </div>
                            </div>
                        
                    }
        </div>
    )
}